/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const ChevronDown = ({ color, width = 20, height = 11, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 11"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 1.39L18.594 0 9.987 8.261l-.918-.881.005.005L1.427.045 0 1.414 9.987 11 20 1.39z"
      />
    </svg>
  )
}

ChevronDown.propTypes = {
  color: string,
  height: number,
  width: number,
}

export default ChevronDown
